<div *ngFor="let column of Columns"
     #Column
     class="grid-table-column-cell-default {{GridColumnFooterClass(column)}}"
     [style.width.px]="column.Width.Px"
     [style.max-width.px]="column.Width.Px"
     [style.min-width.px]="column.Width.Px"
     [style.flex-basis.px]="column.Width.Px">
    <div class="grid-table-column-cell-inner cell-alignment-right" *ngIf="column.IsVisible">
        <div *ngIf="column.Aggregate" [innerHTML]="getAggregate(column)"></div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/grid/grid-columns/grid-column-footer.html